import React from 'react'

function Search({className, placeholder}) {
  return (
    <input className={className} placeholder={placeholder}/>
  )
}

export default Search